/* eslint-disable complexity */
import {
  BookWidgetAem,
  BookWidgetDateField,
  BookWidgetFields,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BOOK_WIDGET_ERROR_CODES } from '../../constants/error-codes.constants';

const validateOneWay = (
  datesField: BookWidgetDateField,
  bookWidgetAem: BookWidgetAem | null
) => {
  if (!datesField.dates[0].start) {
    const errMessage =
      bookWidgetAem?.errorMessages?.[
        BOOK_WIDGET_ERROR_CODES.BOOK_FIELD_ERROR_MISSING_DATE
      ]?.message || 'Error';

    datesField.fieldErrorInfo = [{ errMessage, status: true }];
    return 1;
  }
  return 0;
};

const validateRoundTrip = (
  datesField: BookWidgetDateField,
  bookWidgetAem: BookWidgetAem | null
) => {
  if (!datesField.dates[0].start || !datesField.dates[0].end) {
    const errMessage =
      bookWidgetAem?.errorMessages?.[
        BOOK_WIDGET_ERROR_CODES.BOOK_FIELD_ERROR_MISSING_DATES
      ]?.message || 'Error';

    datesField.fieldErrorInfo = [{ errMessage, status: true }];
    return 1;
  }
  return 0;
};

const validateMultiCity = (
  datesField: BookWidgetDateField,
  bookWidgetAem: BookWidgetAem | null
) => {
  datesField.fieldErrorInfo = [];
  let errorCount = 0;

  datesField.dates.forEach((date, index) => {
    if (!date.start) {
      const errMessage =
        bookWidgetAem?.errorMessages?.[
          BOOK_WIDGET_ERROR_CODES.BOOK_FIELD_ERROR_MISSING_DATE
        ]?.message || 'Error';
      datesField.fieldErrorInfo?.push({ errMessage, status: true });
      errorCount++;
    } else if (
      index > 0 &&
      date.start &&
      datesField.dates
        .slice(0, index)
        .some(
          (prevDate) =>
            prevDate &&
            prevDate.start &&
            date.start &&
            date.start < prevDate.start
        )
    ) {
      const errMessage =
        bookWidgetAem?.errorMessages?.[
          BOOK_WIDGET_ERROR_CODES.BOOK_FIELD_ERROR_INVALID_DATE
        ]?.message || 'Error';
      datesField.fieldErrorInfo?.push({ errMessage, status: true });
      errorCount++;
    } else {
      datesField.fieldErrorInfo?.push({ errMessage: '', status: false });
    }
  });

  return errorCount;
};

export const validateDates = (
  bookWidgetFields: BookWidgetFields,
  fieldsErrorCount: number,
  startFieldsValidation: boolean,
  bookWidgetAem: BookWidgetAem | null
) => {
  const updatedBookWidgetFields: BookWidgetFields = {
    ...bookWidgetFields,
    datesField: { ...bookWidgetFields.datesField }
  };

  delete updatedBookWidgetFields.datesField.fieldErrorInfo;

  if (startFieldsValidation) {
    const { datesField, tripTypesField } = updatedBookWidgetFields;
    const tripType = tripTypesField.selectedTripType;

    if (tripType === TripTypeOptions.ONE_WAY) {
      fieldsErrorCount += validateOneWay(datesField, bookWidgetAem);
    } else if (tripType === TripTypeOptions.ROUND_TRIP) {
      fieldsErrorCount += validateRoundTrip(datesField, bookWidgetAem);
    } else if (tripType === TripTypeOptions.MULTI_CITY) {
      fieldsErrorCount += validateMultiCity(datesField, bookWidgetAem);
    }
  }

  return { fieldsErrorCount, updatedBookWidgetFields };
};
